<ng-container *ngIf="loading">
  <div class="loading-wrapper">
    <ns-skeleton [type]="skeleton"></ns-skeleton>
  </div>
</ng-container>
<mat-toolbar class="bg-white justify-content-end">
  <mat-button-toggle-group (change)="setFilter()" aria-label="Shipments Total" [(ngModel)]="filter">
    <mat-button-toggle value="all">Total: <b>{{ loads + empties }}</b></mat-button-toggle>
    <mat-button-toggle value="L">Loads: <b>{{ loads }}</b></mat-button-toggle>
    <mat-button-toggle value="E">Empties: <b>{{ empties }}</b></mat-button-toggle>
  </mat-button-toggle-group>
</mat-toolbar>
<ng-map
  #mapRef
  class="h-100"
  [config]="config"
  (clearRoute)="clear()"
  (ready)="setup()"
></ng-map>
